// «No molestar» with an end (shared/API.md §41.7): the «Personalizado…» date + time dialog and the
// «hasta HH:mm» line, shared by the profile menu and Configuración › Estado.
import { useState } from 'react';
import { isTwelveHour } from '../../../core/clockStyle';
import { dndCustomDefaults, dndCustomEndTime, dndUntil } from '../../../core/dndSchedule';
import { localTimeZone } from '../../../core/time';
import { locale, t, tf } from '../../../i18n/i18n';
import { Button, Dialog } from '../../kit/Kit';

/** «hasta 14:30» / «hasta mañana 9:00» / «hasta mié 22 oct 9:00», or null without an end. */
export function dndUntilText(endSeconds: number, now: number, hour12: boolean | undefined = isTwelveHour()): string | null {
  const u = dndUntil(endSeconds, now, locale(), localTimeZone(), hour12);
  switch (u.kind) {
    case 'none':
      return null;
    case 'today':
      return tf('web.dnd.until', u.time);
    case 'tomorrow':
      return tf('web.dnd.untilTomorrow', u.time);
    case 'later':
      return tf('web.dnd.untilLater', u.date, u.time);
  }
}

/** Date + time on the reader's own clock; «Activar» sends `dnd_end_time` in seconds. */
export function DndCustomDialog({ onPick, onClose }: { onPick(endSeconds: number): void; onClose(): void }) {
  const initial = dndCustomDefaults(Date.now(), localTimeZone());
  const [date, setDate] = useState(initial.date);
  const [time, setTime] = useState(initial.time);
  const [problem, setProblem] = useState<string | null>(null);
  const submit = () => {
    const r = dndCustomEndTime(date, time, Date.now(), localTimeZone());
    if ('problem' in r) return setProblem(t(r.problem === 'past' ? 'web.dnd.customPast' : 'web.dnd.customInvalid'));
    onPick(r.seconds);
  };
  return (
    <Dialog
      title={t('web.dnd.customTitle')}
      onClose={onClose}
      width={380}
      footer={
        <>
          <Button onClick={onClose}>{t('common.cancel')}</Button>
          <Button kind="primary" onClick={submit}>
            {t('web.dnd.customSave')}
          </Button>
        </>
      }
    >
      <form
        className="st-dnd-custom"
        onSubmit={(e) => {
          e.preventDefault();
          submit();
        }}
      >
        <label className="st-field">
          <span>{t('web.dnd.customDate')}</span>
          <input className="text-input" type="date" value={date} onChange={(e) => (setDate(e.target.value), setProblem(null))} autoFocus />
        </label>
        <label className="st-field">
          <span>{t('web.dnd.customTime')}</span>
          <input className="text-input" type="time" value={time} onChange={(e) => (setTime(e.target.value), setProblem(null))} />
        </label>
        {problem ? (
          <p className="st-save st-save-error" role="alert">
            {problem}
          </p>
        ) : null}
        <button type="submit" hidden />
      </form>
    </Dialog>
  );
}
